/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_3e57f054","_3e57f054",""]'><div :class='["","_3e57f054",""]'><cube-button @_click="showPicker" :class='["","_3e57f054",""]'>time-picker</cube-button><cube-date-picker-popup ref="__mpx_ref_picker__" title="日期选择器" sub-title="请选择具体的时间" cancel-txt="返回" confirm-txt="确定" :min="(min)" :max="(max)" :value="(value)" :startColumn="(startColumn)" @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' :class='["","_3e57f054",""]'/><div :class='["event-params","_3e57f054",""]' v-if="(changeParams.length)"><div :class='["key","_3e57f054",""]'>change 事件参数：</div><div :class='["value","_3e57f054",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_3e57f054",""]'><div :class='["item-key","_3e57f054",""]'>{{item[0]}}</div><div :class='["item-value","_3e57f054",""]'>{{changeTimeStanp(item)}}</div></div></div><div :class='["key","_3e57f054",""]'>columnChange 事件参数：</div><div :class='["value","_3e57f054",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["value-item","_3e57f054",""]'><div :class='["item-key","_3e57f054",""]'>{{item[0]}}</div><div :class='["item-value","_3e57f054",""]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_3e57f054"}'>
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_3e57f054"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_3e57f054"}
  /** script content **/
  require("./time-picker.mpx.js?isComponent&outputPath=components%2Ftime-picker3e57f054%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./time-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftime-picker3e57f054%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_3e57f054"],
    ctorType: "component",
    outputPath: "components/time-picker3e57f054/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker-popup/index.mpx?isComponent&outputPath=components%2Findex012972d9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>